module.exports = __webpack_public_path__ + "static/media/talentai-EN.6ec29112.SVG";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/talentai-EN.SVG
// module id = 686
// module chunks = 0